import { Language } from './types';

/**
 * Asset Control is the office's inventory for PROCOMER, and PROCOMER only
 * accepts Spanish (the office operates under the zona franca regime). Every
 * surface of that module is therefore shown in Spanish regardless of the
 * person's language preference, which stays untouched for the rest of the app.
 */
const SPANISH_ONLY_LANGUAGE: Language = 'es';

interface LocationLike {
  pathname: string;
  search?: string;
}

export const isSpanishOnlyLocation = ({ pathname, search = '' }: LocationLike): boolean => {
  if (pathname.startsWith('/control-activos')) return true;
  if (/^\/reportes\/activos\/?$/.test(pathname)) return true;
  if (/^\/admin\/?$/.test(pathname)) {
    return new URLSearchParams(search).get('tab') === 'activos';
  }
  return false;
};

/** Language a location must be painted in, or `undefined` to follow the person's choice. */
export const forcedLanguageFor = (location: LocationLike): Language | undefined =>
  isSpanishOnlyLocation(location) ? SPANISH_ONLY_LANGUAGE : undefined;
